<template>
  <footer class="layout-footer">
    <p>© 2025 Bill.Wei Word Flow Learning System</p>
    <div class="flex gap-2 fle-wrap items-center justify-center text-xs text-grey-500">
      <img src="../../assets/icon-gongan.png" width="16" height="16">
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31011702891286" rel="noreferrer" target="_blank">沪公网安备31011702891286号</a>
      <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2026004263号-1</a>
    </div>
  </footer>
</template>
